export namespace ScrollBarStates {
    export function scrollBarStatesFactory() {
        const scrollBar: any = {
            scrollY: 0,
        };
        return scrollBar;
    }

    export function mutations() {
        return {
            onScrollY(state: any, value: any) {
                state.scrollBar.scrollY = value;
            }
        };
    }
}
